export function addDecimalsToNumber(num) {
    // Convertir el número a un string y luego a un número flotante
    // para manejar casos donde el número es un string.
    const number = parseFloat(num);
  
    // Usar toFixed para convertir el número a un string con dos decimales
    return number.toFixed(2);
  }